'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { Stamp } from '@src/components/TopNavV5/Stamp';
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context';
import type { TopNavV5SubMenu } from '@src/components/TopNavV5/TopNavV5Props';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
export const TopNavV5MobileLeftMenu = () => {
  const $ = _c(20);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    mobileDispatch,
    mobileState
  } = useTopNavV5();
  const renderTitle = _temp;
  if (mobileState.state !== "left-menu-open") {
    return null;
  }
  const items = mobileState.leftMenu?.items;
  let t0;
  if ($[0] !== mobileDispatch) {
    t0 = () => {
      mobileDispatch({
        type: "BACK_FROM_LEFT_MENU"
      });
    };
    $[0] = mobileDispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ChevronLeftIcon className="size-5 text-bodi-accent-bright-500" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = mobileState.leftMenu?.title;
  let t3;
  if ($[3] !== t2) {
    t3 = <p className="text-heading-4 text-left font-lateral">{t2}</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = mobileState.leftMenu?.stamp;
  let t5;
  if ($[5] !== t4) {
    t5 = <Stamp text={t4} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t0 || $[8] !== t3 || $[9] !== t5) {
    t6 = <div className="flex h-14 items-center border-b border-white/10 p-4"><button onClick={t0} className="flex items-center gap-2">{t1}{t3}{t5}</button></div>;
    $[7] = t0;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== items || $[12] !== mobileDispatch || $[13] !== trackSelectNavCta) {
    t7 = items?.map((item, index) => {
      if (item.isLink) {
        return <LocalizedLink onClick={() => {
          trackSelectNavCta({
            "cta url": item.link?.href ?? ""
          });
          mobileDispatch({
            type: "CLOSE_FROM_MAIN"
          });
        }} data-testid={`nav-menu-${index}`} key={`${item.title}-${index}`} className="py-3 text-heading-4 font-lateral font-medium text-left" href={item.link?.href ?? ""} rel={item.link?.newTab ? "noopener noreferrer" : ""} target={item.link?.newTab ? "_blank" : "_self"}>{renderTitle(item)}</LocalizedLink>;
      }
      return <button data-testid={`nav-menu-${index}`} key={`${item.title}-${index}`} className={cn("py-3 text-heading-4 font-lateral font-medium text-left", "relative flex w-full cursor-pointer items-center gap-2 transition-all")} onClick={() => {
        mobileDispatch({
          type: "OPEN_LEFT_MENU_SUB_MENU",
          payload: {
            leftMenuIndex: index
          }
        });
      }}>{renderTitle(item)}<ChevronRightIcon className="size-5 text-bodi-accent-bright-500" /></button>;
    });
    $[11] = items;
    $[12] = mobileDispatch;
    $[13] = trackSelectNavCta;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <div className="flex flex-col gap-2 px-4 py-6 pt-4">{t7}</div>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div>{t6}{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
function _temp(menu) {
  return <div className="flex w-fit items-center gap-2">{menu.title}<Stamp text={menu.stamp} /></div>;
}